module.exports = {"650102002":"燕儿窝街道","650102003":"胜利路街道","650102004":"团结路街道","650102005":"解放南路街道","650102006":"新华南路街道","650102007":"和平路街道","650102008":"解放北路街道","650102009":"幸福路街道","650102010":"东门街道","650102011":"新华北路街道","650102012":"青年路街道","650102013":"碱泉街道","650102014":"延安路街道","650102015":"红雁街道","650102016":"南草滩街道","650102017":"东泉路街道","650102400":"二道桥片区","650102401":"黑甲山片区","650102402":"大湾片区","650102403":"赛马场片区","650102404":"南湾街片区","650102405":"大巴扎片区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650102.json
// module id = 3189
// module chunks = 0